
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ICodeAndDescription } from "@tylertech/tyler-api-types";

/**
 * FormCodeService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class FormCodeService {
    private readonly $apiService = inject(ApiService);
    
    GetFormCodes(pFormTypeValue: string): Promise<ICodeAndDescription[]> {
        return this.$apiService.sendAuth("IFormCodeService/GetFormCodes", pFormTypeValue);
    }
}
